import { captureException } from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

import { TaxData } from '../types';

async function fetchData(signal: AbortSignal) {
	try {
		const response = await fetch(`/data/tax/data.json`, { signal });
		const data = await response.json();
		return data as TaxData;
	} catch (error) {
		console.error(error);
		captureException(error);
		throw error;
	}
}

export function useData() {
	const { data, isLoading, error } = useQuery({
		queryKey: ['tax-data'],
		queryFn: async ({ signal }) => fetchData(signal),
	});

	return {
		data,
		isLoading,
		error,
	};
}
